import React from 'react';
import i18n from '@i18n';
import { cashinRejectedReason } from '@/mytickets/constants/cashinRejectedReason';
import { firstToUpperCase } from '@/common/client';
import { DialogActions, DialogBody, DialogButton, DialogTitle } from '@/ui/dialogs/Dialog';

function CashinRejection({ cashinTransaction, closeDialog }) {
    let reason = cashinTransaction.get('reason');
    switch (reason) {
        case cashinRejectedReason.PayoutFailed:
            reason = i18n('ticketus.cashin.rejected.PayoutFailed');
            break;
        case cashinRejectedReason.RejectedByBookmaker:
            reason = i18n('ticketus.cashin.rejected.RejectedByBookmaker');
            break;
        default:
            reason = i18n('ticketus.cashin.rejected');
    }

    return (
        <div className="cashin-rejection">
            <DialogTitle>
                <h2 className="icon">{firstToUpperCase(i18n('commons.term.odkupH1'))}</h2>
            </DialogTitle>
            <DialogBody>{reason}</DialogBody>
            <DialogActions>
                <DialogButton onClick={() => closeDialog(reason)}>{i18n('cashin.term.close')}</DialogButton>
            </DialogActions>
        </div>
    );
}

export default CashinRejection;
